
export default {
  setDeviceAreaList (state, data) {
    state.deviceAreaList = data
  },
  setDeviceInstallSiteList (state, data) {
    state.deviceInstallSiteList = data
  },
  setDeviceConsumeSiteList (state, data) {
    state.deviceConsumeSiteList = data
  },
  setPersonList (state, personList) {
    state.personList = personList
  },
  setDepartmentTree (state, data) {
    state.departmentTree = data
  },
  setApplyTypeList (state, data) {
    state.applyTypeList = data
  },
  setWelfareList (state, data) {
    state.welfareList = data
  },
  setWorkTimeList (state, data) {
    state.workTimeList = data
  },
  setPosNoLIst (state, data) {
    state.posNoLIst = data
  },
  setRechargeTypeSorts (state, data) {
    state.rechargeTypeSorts = data
  },
  setRechargeTypeLists (state, data) {
    state.rechargeTypeLists = data
  },
  setMachineDealTypeSorts (state, data) {
    state.machineDealTypeSorts = data
  },
  setClearFlagSorts (state, data) {
    state.clearFlagSorts = data
  },
  setRefMethodSorts (state, data) {
    state.refMethodSorts = data
  },
  setIncomeDealTypeSorts (state, data) {
    state.incomeDealTypeSorts = data
  },
  clearConsumeDropDownList (state) {
    state.deviceAreaList = []
    state.incomeDealTypeSorts = []
    state.deviceInstallSiteList = []
    state.deviceConsumeSiteList = []
    state.applyTypeList = []
    state.welfareList = []
    state.workTimeList = []
    state.posNoLIst = []
    state.benefitsTypeSorts = []
    state.rechargeTypeLists = []
    state.rechargeTypeSorts = []
    state.dislimitTypeSorts = []
    state.personnelGroupSorts = []
    state.accountTypeSorts = []
    state.peronAccountStatusSorts = []
    state.accountDirectionSorts = []
    state.exceptionalTypeSorts = []
    state.exceptionalProcFlagSorts = []
    state.bfuseageSorts = []
    state.tranTypeSorts = []
    state.dishSorts = []
    state.machineDealTypeSorts = []
    state.orderTypeSorts = []
    state.orderPayFlagSorts = []
    state.merchantTypeSorts = []
    state.terminalTypeSorts = []
    state.feeTypeSorts = []
    state.clearFlagSorts = []
    state.refMethodSorts = []
    state.saleChannelList = []
  },
  setMerchantTypeSorts (state, data) {
    state.merchantTypeSorts = data
  },
  setTerminalTypeSorts (state, data) {
    state.terminalTypeSorts = data
  },
  setBfuseageSorts (state, data) {
    state.bfuseageSorts = data
  },
  setBenefitsTypeSorts (state, data) {
    state.benefitsTypeSorts = data
  },
  setDisLimitTypeSorts (state, data) {
    state.dislimitTypeSorts = data
  },
  setPersonnelGroupSorts (state, data) {
    state.personnelGroupSorts = data
  },
  setAccountTypeSorts (state, data) {
    state.accountTypeSorts = data
  },
  setPeronAccountStatusSorts (state, data) {
    state.peronAccountStatusSorts = data
  },
  setAccountDirectionSorts (state, data) {
    state.accountDirectionSorts = data
  },
  setExceptionalTypeSorts (state, data) {
    state.exceptionalTypeSorts = data
  },
  setExceptionalProcFlagSorts (state, data) {
    state.exceptionalProcFlagSorts = data
  },
  setTranTypeSorts (state, data) {
    state.tranTypeSorts = data
  },
  setDishSorts (state, data) {
    state.dishSorts = data
  },
  setOrderTypeSorts (state, data) {
    state.orderTypeSorts = data
  },
  setOrderPayFlagSorts (state, data) {
    state.orderPayFlagSorts = data
  },
  setFeeTypeSorts (state, data) {
    state.feeTypeSorts = data
  },
  setFeePayMethod (state, data) {
    state.feePayMethod = data
  },
  setSaleChannelList (state, data) {
    state.saleChannelList = data
  }
}



// WEBPACK FOOTER //
// ./src/store/consume/mutations.js